/* eslint-disable import/no-cycle */
import useJwt from '@/auth/jwt/useJwt'
import generateSearchQuery from '../../helpers/generateSearchQuery'
import { adminPermissions } from '../../helpers/permissions'

const { axiosIns } = useJwt
// const baseUrl = 'https://sandbox-base-operations.udara360.io/api/'
export default {
  getAllPermission: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/base/api/Permission/v1/GetAll')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  addRole: async (context, data) => {
    try {
      useJwt.setPermission(adminPermissions.CREATE_USER_ROLE)
      const response = await axiosIns.post('/base/api/Role/v1/Add', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  editRole: async (context, data) => {
    try {
      useJwt.setPermission(adminPermissions.MODIFY_USER_ROLE)
      const response = await axiosIns.put('/base/api/Role/v1/update', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getRoles: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/Role/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getUserByRoleId: async (context, { id, status, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/base/api/User/v1/Search?Role=${id}&Status=${status}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAllRoles: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/base/api/Role/v1/GetAll')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getUsers: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/User/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getUserList: async (context, { status, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/base/api/User/v1/Search?status=${status}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getUserByEmail: async (context, { email, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/base/api/User/v1/Search?email=${email}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSubscriptionConfigAction: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/base/api/Subscription/v1/GetConfig')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSubscriptionInvoice: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/Subscription/v1/SearchInvoice',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSubscriptionPaymentHistory: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/Subscription/v1/SearchPaymentsHistory',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  initializePaymentAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/base/api/Subscription/v1/InitializePayment', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  initializePaymentWithAmount: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/base/api/Subscription/v1/InitializePaymentWithAmount', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  addUser: async (context, data) => {
    try {
      useJwt.setPermission(adminPermissions.CREATE_USER)
      const response = await axiosIns.post('/base/api/user/v1/Add', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  editUser: async (context, data) => {
    try {
      useJwt.setPermission(adminPermissions.MODIFY_USER)
      const response = await axiosIns.put('/base/api/user/v1/update', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateUserStatus: async (context, { statusValues, actionType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const route = actionType === 'Active' ? 'Activate' : 'Deactivate'
      const response = await axiosIns.put(`/base/api/user/v1/${route}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  resetUserPassword: async (context, { id }) => {
    try {
      useJwt.setPermission(adminPermissions.RESET_PASSWORD)
      const response = await axiosIns.put(`/base/api/user/v1/resetpassword?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  sendEmailPasswordAction: async (context, data) => {
    try {
      useJwt.setPermission(adminPermissions.RESET_PASSWORD)
      const response = await axiosIns.put('/base/api/user/v1/EmailPassword', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  disabledAuthenticator: async (context, { id }) => {
    try {
      useJwt.setPermission(adminPermissions.RESET_PASSWORD)
      const response = await axiosIns.delete(`/base/api/Authentication/v1/DeleteAppSeed?UserId=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getUserSystemAccess: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/SystemAccess/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateSystemStatus: async (context, { statusValues, actionType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const route = actionType === 'Active' ? 'Activate' : 'Deactivate'
      const response = await axiosIns.put(`/base/api/SystemAccess/v1/${route}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  fetchDataHandlingReport: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/DataHandlingReport/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
